import { useState, useCallback, useMemo } from "react";
import { CloudUploadIcon, CrossIcon } from "../../../assets/icons";
import UploadBiblografiaModal from "../../Common/UploadPdfModal/UploadPdfModal";
import { uploadFile } from "../../../api";
import { toast } from "react-toastify";
import PdfImg from "../../../assets/images/pdf_icon.svg";
import SpinnerLoading from "../../SpinnerLoading/SpinnerLoading";
import { useBrowseFile } from "../../../hooks/useBrowseFile";
import { getPdfAllegati } from "../helpers/allegatiHelpers";
import "./UploadBiblografia.scss";

const UploadBiblografia = ({ idPdfBibliografia = [], disabled, onChange }) => {
  const pdfAttachments = useMemo(
    () => getPdfAllegati(idPdfBibliografia),
    [idPdfBibliografia]
  );
  const [showModal, setShowModal] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const { handleBrowseFile } = useBrowseFile();

  const openModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  const handleUpload = useCallback(
    async (ev) => {
      const files = ev.target.files;
      closeModal();
      setIsFileUploading(true);

      if (files.length) {
        Array.from(files).forEach(async (file) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = async function () {
            try {
              const uploadedFileId = await uploadFile(file);

              onChange([
                ...idPdfBibliografia,
                { id: uploadedFileId, name: file.name },
              ]);
            } catch (error) {
              console.error("Error uploading file.", error);
              toast.error("Error uploading file.");
            } finally {
              setIsFileUploading(false);
            }
          };

          if (!file.name.endsWith(".pdf")) {
            console.error("Unsupported file format.");
            toast.error("Unsupported file format.");
            setIsFileUploading(false);
          }
        });
      }
    },
    [idPdfBibliografia, onChange, closeModal]
  );

  const handleRemovePdf = useCallback(
    (fileId) => {
      onChange(idPdfBibliografia.filter((pdf) => pdf.id !== fileId));
    },
    [idPdfBibliografia, onChange]
  );

  return (
    <div className="form-block">
      <div className="form-block-header">
        <p className="form-block-header-title">Allegati</p>
        <button
          className="upload-biblografia-btn"
          disabled={disabled}
          onClick={openModal}
        >
          <CloudUploadIcon fillColor="var(--archeo-color)" />
          <span>Carica PDF</span>
        </button>
      </div>
      <div>
        {isFileUploading ? (
          <SpinnerLoading isLoading={isFileUploading} />
        ) : null}
        <div className="preveiw-container">
          {pdfAttachments?.length
            ? pdfAttachments.map((pdf) => (
                <div key={pdf?.id} className="biblografia-pdf-container">
                  <button onClick={() => handleBrowseFile(pdf?.id, "pdf")}>
                    <img src={PdfImg} alt="pdf" />
                    <p>{pdf?.name}</p>
                  </button>
                  <span
                    className={`pdf-close-icon ${disabled ? "disabled" : ""}`}
                    onClick={() => handleRemovePdf(pdf?.id)}
                  >
                    <CrossIcon />
                  </span>
                </div>
              ))
            : null}
        </div>
      </div>
      <UploadBiblografiaModal
        title={"Upload PDF"}
        showModal={showModal}
        handleUpload={handleUpload}
        closeModal={closeModal}
      />
    </div>
  );
};

export default UploadBiblografia;
